import React from 'react'

const JoinUs = () => {
  return (
    <div className="p-10">
      <div className="flex flex-row gap-10 "> 
        <p className="w-[200px] text-[35px] text-[#FFC107]">JOIN US TODAY</p>
        <p className="w-[400px]">The Global NGO Executive Committee is comprised of eighteen representatives elected by organizations officially associated with the United Nations Department of Global Communications (DGC).

 

The Executive Committee was founded to promote a closer working relationship between the United Nations and the NGOs associated with UN DGC. GNEC acts as a liaison between the NGO community and UN. It helps constituents make more effective use of their association with the UN DGC.</p>
      </div>
    </div>
  )
}

export default JoinUs